// @flow

class GstIn {
  constructor(number: string, valid: boolean) {
    this.number = number;
    this.valid = valid;
  }
}

GstIn.prototype.validLength = '15';

GstIn.prototype.inputType = 'text';

GstIn.prototype.validRegex =
  '[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}';

GstIn.prototype.validateGstIn = (gstIn: GstIn) =>
  gstIn &&
  gstIn.number &&
  gstIn.number.length === Number(GstIn.prototype.validLength) &&
  gstIn.number.match(GstIn.prototype.validRegex);

export default GstIn;
